"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React, {
  Component,
  createRef,
  cloneElement,
  Children
} from "react";
import { createPortal } from "react-dom";
import { action, observable, computed } from "mobx";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import getPortalRoot from "../../../utils/getPortalRoot";
import { randomString, shouldUpdatePosition } from "../../../utils";
import getOverlayPosition from "../../../utils/getOverlayPosition";
import observeRect from "@reach/observe-rect";
import { isEqual } from "lodash";
import { Layer } from "../../../utils/layers/LayerContext";
import * as styles from "./Tooltip-css";
import { darkTheme, duration, lightTheme } from "../../../tokens/tokens-css";
import { assignInlineVars } from "@vanilla-extract/dynamic";
export var TooltipSize = /* @__PURE__ */ ((TooltipSize2) => {
  TooltipSize2["Small"] = "small";
  TooltipSize2["Large"] = "large";
  return TooltipSize2;
})(TooltipSize || {});
export var TooltipPosition = /* @__PURE__ */ ((TooltipPosition2) => {
  TooltipPosition2["Top"] = "top";
  TooltipPosition2["Bottom"] = "bottom";
  TooltipPosition2["Left"] = "left";
  TooltipPosition2["Right"] = "right";
  return TooltipPosition2;
})(TooltipPosition || {});
let Tooltip = class extends Component {
  constructor() {
    super(...arguments);
    this.targetRef = createRef();
    this.portalRoot = getPortalRoot("tooltip-root");
    this.id = randomString();
    this.show = false;
    this.handleEnter = (event, handleEvent) => {
      handleEvent == null ? void 0 : handleEvent(event);
      this.show = true;
    };
    this.handleLeave = (event, handleEvent) => {
      handleEvent == null ? void 0 : handleEvent(event);
      this.show = false;
    };
    this.handleKeyDown = (event, handleEvent) => {
      handleEvent == null ? void 0 : handleEvent(event);
      if (event.key === "Escape") {
        this.show = false;
      }
    };
  }
  render() {
    const { content, size, children, className, wrapTarget, targetClassName, position, offset, isError, style, theme } = this.props;
    const show = (this.isControlledTooltip ? this.props.show : this.show) && !!this.targetRef.current;
    const tooltipId = `tooltip-${this.id}`;
    const child = wrapTarget ? null : Children.only(children);
    const targetProps = {
      ["aria-describedby"]: show ? tooltipId : void 0,
      tabIndex: isError ? void 0 : 0,
      onFocus: (event) => this.handleEnter(event, child == null ? void 0 : child.props.onFocus),
      onBlur: (event) => this.handleLeave(event, child == null ? void 0 : child.props.onBlur),
      onMouseEnter: (event) => this.handleEnter(event, child == null ? void 0 : child.props.onMouseEnter),
      onMouseLeave: (event) => this.handleLeave(event, child == null ? void 0 : child.props.onMouseLeave),
      onKeyDown: (event) => this.handleKeyDown(event, child == null ? void 0 : child.props.onKeyDown)
    };
    return /* @__PURE__ */ React.createElement("div", { className: classNames("kl-tooltip-target", targetClassName), ref: this.targetRef }, /* @__PURE__ */ React.createElement(Transition, { mountOnEnter: true, unmountOnExit: true, in: show, timeout: duration.m, onEnter: forceReflow }, (status) => createPortal(
      /* @__PURE__ */ React.createElement(Layer, null, ({ zIndex }) => /* @__PURE__ */ React.createElement(
        TooltipElement,
        {
          id: tooltipId,
          targetRef: this.targetRef,
          position,
          size,
          onMouseEnter: this.isControlledTooltip ? this.handleEnter : void 0,
          onMouseLeave: this.isControlledTooltip ? this.handleLeave : void 0,
          className: classNames(className),
          theme,
          transitionStatus: status,
          offset,
          isError,
          style: __spreadValues({ zIndex: this.props.autoStack ? zIndex : void 0 }, style)
        },
        content
      )),
      this.portalRoot
    )), child == null ? /* @__PURE__ */ React.createElement("div", __spreadValues({ className: classNames("kl-tooltip-target__wrapper", styles.wrapper) }, targetProps), children) : cloneElement(child, targetProps));
  }
  get isControlledTooltip() {
    return this.props.show !== void 0 && this.props.show !== null;
  }
};
Tooltip.defaultProps = {
  size: "small" /* Small */,
  position: "top" /* Top */,
  offset: 4
};
__decorateClass([
  observable.shallow
], Tooltip.prototype, "targetRef", 2);
__decorateClass([
  observable
], Tooltip.prototype, "show", 2);
__decorateClass([
  action
], Tooltip.prototype, "handleEnter", 2);
__decorateClass([
  action
], Tooltip.prototype, "handleLeave", 2);
__decorateClass([
  action
], Tooltip.prototype, "handleKeyDown", 2);
__decorateClass([
  computed
], Tooltip.prototype, "isControlledTooltip", 1);
Tooltip = __decorateClass([
  observer
], Tooltip);
export {
  Tooltip as default
};
export let TooltipElement = class extends Component {
  constructor(props) {
    var _a;
    super(props);
    this.tooltipRef = createRef();
    this.caretSize = 8;
    this.handleRectObserver = (targetRect) => {
      var _a;
      if (!targetRect || !shouldUpdatePosition(targetRect))
        return;
      const { position, offset } = this.props;
      const overlayRect = (_a = this.tooltipRef.current) == null ? void 0 : _a.getBoundingClientRect();
      this.tooltipPosition = getOverlayPosition({
        position,
        offset,
        targetRect,
        overlayRect,
        caretSize: this.caretSize,
        outerMargin: 4
      });
    };
    this.onMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    this.tooltipRef = (_a = props.forwardRef) != null ? _a : createRef();
  }
  componentDidMount() {
    var _a;
    if ((_a = this.props.targetRef) == null ? void 0 : _a.current) {
      this.rectObserver = observeRect(this.props.targetRef.current, this.handleRectObserver);
      this.rectObserver.observe();
    }
  }
  componentDidUpdate(prevProps) {
    var _a;
    if (!isEqual(prevProps, this.props) && ((_a = this.props.targetRef) == null ? void 0 : _a.current)) {
      this.handleRectObserver(this.props.targetRef.current.getBoundingClientRect());
    }
  }
  componentWillUnmount() {
    var _a;
    (_a = this.rectObserver) == null ? void 0 : _a.unobserve();
  }
  render() {
    var _a;
    const {
      id,
      style,
      size,
      className,
      children,
      onMouseEnter,
      onMouseLeave,
      transitionStatus,
      position,
      isError,
      theme
    } = this.props;
    const positionModifier = ((_a = this.tooltipPosition) == null ? void 0 : _a.modifier) || position;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "aria-live": "polite",
        id,
        ref: this.tooltipRef,
        style: __spreadValues(__spreadValues({}, style), this.tooltipPosition ? assignInlineVars({
          [styles.top]: `${this.tooltipPosition.overlay.top}px`,
          [styles.left]: `${this.tooltipPosition.overlay.left}px`
        }) : {}),
        contentEditable: false,
        className: classNames(
          "kl-tooltip",
          `kl-tooltip--${positionModifier}`,
          `kl-tooltip--${size}`,
          `kl-tooltip--${transitionStatus}`,
          styles.tooltip({ position, status: transitionStatus, error: isError, size }),
          className,
          {
            [lightTheme]: theme === "light",
            [darkTheme]: !theme || theme === "dark"
          }
        ),
        role: isError ? "alert" : "tooltip",
        onMouseEnter,
        onMouseLeave,
        onMouseDown: this.onMouseDown
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            "kl-tooltip__caret",
            `kl-tooltip__caret--${positionModifier}`,
            styles.caret({ position: positionModifier })
          ),
          style: __spreadValues(__spreadValues({}, assignInlineVars({ [styles.caretSize]: `${this.caretSize}px` })), this.tooltipPosition ? assignInlineVars({
            [styles.caretTop]: `${this.tooltipPosition.caret.top}px`,
            [styles.caretLeft]: `${this.tooltipPosition.caret.left}px`
          }) : {})
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: classNames("kl-tooltip__content", styles.content({ size })) }, children)
    );
  }
};
TooltipElement.defaultProps = {
  transitionStatus: "entered"
};
__decorateClass([
  observable.ref
], TooltipElement.prototype, "tooltipPosition", 2);
__decorateClass([
  action
], TooltipElement.prototype, "handleRectObserver", 2);
TooltipElement = __decorateClass([
  observer
], TooltipElement);
